import React, { Fragment } from 'react';
import { string, array } from 'prop-types';
import Item from './item';
import A from '../../platformui/Anchor';

const propTypes = {
  LinkText: string,
  LinkUrl: string,
  /** See <Item> component */
  SearchHits: array,
};

const ItemList = (props) => {
  const { SearchResult } = props;
  const { SearchHits } = SearchResult;

  const btnAttr = {
    href: props.LinkUrl,
    className: 'link-item-list__button',
    buttonStyling: true,
  };

  return (
    <Fragment>
      <ul className="search-list link-item-list">
        {SearchHits.map((item, index) => {
          return <Item key={index} {...props} {...item} item={item} />;
        })}
      </ul>
      <A {...btnAttr}>
        <span>{props.LinkText}</span>
      </A>
    </Fragment>
  );
};

ItemList.propTypes = propTypes;

export default ItemList;
